import {
  IsArray,
  IsNotEmpty,
  IsUUID,
  IsDateString,
  IsOptional,
  IsString,
  IsBoolean,
  IsInt,
  IsPositive,
} from 'class-validator';
import { Type } from 'class-transformer';

import type { FileInputValue } from '@vk-hr-tek/ui/input';

const notEmptyOptions = {
  message: 'Обязательное поле',
};

export class CreatePolicyDto {
  @IsNotEmpty(notEmptyOptions)
  name: string;

  @IsUUID()
  @IsString()
  @IsOptional()
  categoryId: string;

  @IsNotEmpty(notEmptyOptions)
  @Type(() => String)
  files: FileInputValue[];

  @IsUUID()
  @IsString()
  @IsNotEmpty(notEmptyOptions)
  companyId: string;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  unitIds?: string[];

  @IsOptional()
  unitType?: string;

  @IsArray()
  @Type(() => String)
  @IsOptional()
  positions?: string[];

  @IsArray()
  @Type(() => String)
  @IsOptional()
  employees?: string[];

  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  activeFrom: string;

  @IsDateString()
  @IsOptional()
  activeTo?: string;

  @IsInt()
  @IsPositive()
  @Type(() => Number)
  @IsOptional()
  acceptancePeriodDays?: number;

  @IsDateString()
  @IsNotEmpty(notEmptyOptions)
  documentDate: string;

  @IsOptional()
  documentNumber?: string;

  @IsNotEmpty(notEmptyOptions)
  signatureType: 'pep' | 'unep';

  @IsBoolean()
  @IsNotEmpty(notEmptyOptions)
  withOrder: boolean;

  @IsString()
  @IsOptional()
  govDocument?: string;

  @IsString()
  @IsOptional()
  govDocumentTypeCode?: string;

  @IsBoolean()
  @IsOptional()
  hideIfAccepted?: boolean;

  @IsOptional()
  @Type(() => String)
  additionalFiles?: FileInputValue[];

  @IsString()
  @IsOptional()
  employeesAddingMode?: 'manual' | 'upload';

  @IsBoolean()
  @IsOptional()
  includeUnitManagers?: boolean;
}
